import { memoirThemes } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Themes() {
  return (
    <section id="themes" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-14">
        <div className="flex flex-col">
          <SectionHeading
            eyebrow="Themes"
            title="回忆录里，都在写些什么"
            description="长日光阴记录的从不是传奇，而是普通人和普通日子。下面这六个方向，几乎涵盖了每一段被认真写下的旧时光。"
          />
          <div className="mt-8 w-full h-56 sm:h-72 rounded-lg overflow-hidden border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20stylized%20illustration%20of%20an%20open%20vintage%20journal%20with%20pressed%20dried%20flowers%20and%20old%20photographs%20scattered%20on%20a%20linen%20cloth%2C%20a%20cup%20of%20tea%20beside%20it%2C%20soft%20side%20daylight%2C%20cream%20and%20warm%20brown%20palette%2C%20painterly%20texture%2C%20intimate%20memoir%20atmosphere%2C%20editorial%20still%20life&width=800&height=600&seq=theme-still-01&orientation=landscape"
              alt="摊开的旧日记本，夹着干花与老照片，旁边放着一杯茶，长日光阴回忆录主题"
              title="长日光阴 · 旧日记本与老照片"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {memoirThemes.map((theme) => (
            <article
              key={theme.title}
              className="flex flex-col bg-background-100 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors"
            >
              <span className="w-11 h-11 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${theme.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {theme.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{theme.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}